import { Box } from '@mui/material'
import JobAdWindow from 'module/recruitment/pages/recruitment-create-job-ad/components/JobAdWindow'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useEffect } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'
import { getOneJobAds, updateJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'

const EditJobAd = () => {
  const location = useLocation()
  const id = location.state.id
  const errorSnackbar = useOpenClose(false)
  const saveSuccessSnackbar = useOpenClose(false)

  // CALL API
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getOneJobAds')
    queryClient.resetQueries('getOneJobAds')
  }, [])
  const { isLoading: getOneJobAdsIsLoading, data: getOneJobAdsData } = useQuery(
    ['getOneJobAds', id],
    async () => {
      const { data } = await getOneJobAds(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const {
    isLoading: editMutateisLoading,
    isSuccess: editMutateIsSuccess,
    mutate: editMutate,
  } = useMutation((value) => updateJobAds(id, 'update', value), {
    onSuccess: (response) => {
      console.log(response)
      saveSuccessSnackbar.handleOpen()
    },
    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })

  const handleUpdateJobAds = (e) => {
    const data = e
    delete data.applications_count
    delete data.advertisement_status
    delete data.expired_date
    delete data.id
    delete data.onet_code
    delete data.job_level_name
    delete data.publish_at
    delete data.purchased_count
    delete data.update_count
    delete data.updated_at
    delete data.user_id
    delete data.urgency
    delete data.view_count
    delete data.academic_field
    delete data.created_at
    delete data.mobility
    delete data.qualification
    delete data.job_category_id
    delete data.course
    if (data.skill !== null && typeof data.skill !== 'object') {
      const updatedData = {
        ...data,
        skill: data.skill.split(','),
      }
      editMutate(updatedData)
    } else {
      const updatedData = {
        ...data,
      }
      editMutate(updatedData)
    }
  }

  const handleSubmit = (e) => {
    //remove unwanted data before sending payload to api
    const data = e
    delete data.applications_count
    delete data.advertisement_status
    delete data.expired_date
    delete data.id
    delete data.onet_code
    delete data.job_level_name
    delete data.publish_at
    delete data.purchased_count
    delete data.update_count
    delete data.updated_at
    delete data.user_id
    delete data.urgency
    delete data.view_count
    delete data.academic_field
    delete data.created_at
    delete data.job_advertisement_duration
    delete data.mobility
    delete data.qualification
    delete data.job_category_id
    delete data.course

    if (data.skill !== null && typeof data.skill !== 'object') {
      const updatedData = {
        ...data,
        skill: data.skill.split(','),
      }
      editMutate(updatedData)
    } else {
      const updatedData = {
        ...data,
      }
      editMutate(updatedData)
    }
  }
  // WILL REFACTOR THIS LEGACY OLD CODE SOON!!! !reminder(afi)
  return (
    <Box>
      <JobAdWindow
        formTitle={getOneJobAdsData?.position_title}
        editJobAds={true}
        onSubmit={handleSubmit}
        handleUpdateJobAds={handleUpdateJobAds}
        createJobPostingPublishisLoading={editMutateisLoading}
        createJobPostingPublishIsSuccess={editMutateIsSuccess}
        editIsLoading={getOneJobAdsIsLoading}
        initialValues={getOneJobAdsData}
      />
      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}
      {saveSuccessSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job successfully saved"
          open={saveSuccessSnackbar.isOpen}
          handleClose={saveSuccessSnackbar.handleClose}
        />
      ) : null}
    </Box>
  )
}
export default EditJobAd
